/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Notion_WhatInputs */

const en_mk_cmp_notion_what = /** @type {(inputs: Mk_Cmp_Notion_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notion is a highly flexible document and database workspace — you build the structure yourself. Notion Agent is available on Business, and Custom Agents (Business/Enterprise) can be triggered by a schedule, a Slack message, an email or a database change. Since May 2026 Custom Agents are billed per credit on top of the plan, around $10 per 1,000 credits.`)
};

const id_mk_cmp_notion_what = /** @type {(inputs: Mk_Cmp_Notion_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notion adalah ruang kerja dokumen dan basis data yang sangat lentur — Anda menyusun sendiri strukturnya. Notion Agent tersedia di paket Business, dan Custom Agents (Business/Enterprise) bisa dipicu jadwal, pesan Slack, email, atau perubahan basis data. Sejak Mei 2026 Custom Agents ditagih per kredit di atas harga paket, sekitar $10 per 1.000 kredit.`)
};

/**
* | output |
* | --- |
* | "Notion is a highly flexible document and database workspace — you build the structure yourself. Notion Agent is available on Business, and Custom Agents (Bus..." |
*
* @param {Mk_Cmp_Notion_WhatInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_notion_what = /** @type {((inputs?: Mk_Cmp_Notion_WhatInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Notion_WhatInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_notion_what(inputs)
	return en_mk_cmp_notion_what(inputs)
});